import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return data?.map(item => ({
      ...item,
      charge_ids: item.charges.map(item => item.misc_fee_charge_template_id),
    }))
  }, [data])
}
